"use client"

import { DefaultImage } from "@/lib/external-components"
import { toImageSrc } from "@/lib/utils"
import { MemberListItemProps } from "@/types/types"
import Image from "next/image"
import Link from "next/link"

export const MemberListItem = ({ member, className = "" }: MemberListItemProps) => {
  const imageUrl = member.image ? toImageSrc(member.image) : DefaultImage
  const link = member.link || "#"

  const content = (
    <div className={`flex flex-col items-center gap-y-[4.9375rem] sm:gap-y-[0.6875rem] ${className}`}>
      <div className="relative w-full h-[168px] sm:max-w-[300px] sm:h-[320px] bg-white hover:bg-transparent rounded-lg overflow-hidden mb-4 transition-all duration-300 group">
        <Image
          src={imageUrl}
          alt={member.name || "Member"}
          fill
          className="object-cover group-hover:brightness-125 transition-all duration-300"
          sizes="(max-width: 640px) 157.6px, 300px"
        />
      </div>

      <div className="text-center">
        {member.name && (
          <h3 className="text-base md:text-xl font-semibold text-[#212529] sm:mb-[0.9375rem] mb-0">{member.name}</h3>
        )}
        {member.position && <p className="text-base md:text-lg text-[#333333] leading-[1.625rem]">{member.position}</p>}
      </div>
    </div>
  )

  if (link !== "#") {
    return (
      <Link href={link} className="block hover:opacity-90 transition-opacity">
        {content}
      </Link>
    )
  }

  return content
}
